const DATE_SEPARATOR = 2;

const PRIVACY_POLICY_LINK_SPAIN =
    'https://www.zinia.com/assets/CF_ES/es-ES/documents/v1/ES.ZINIA.LINKUP.PRIVACY_POLICY_PAGO_FLEXIBLE.pdf',
  PRIVACY_POLICY_LINK_OTHERS =
    'https://www.zinia.com/assets/CF_ES/en-GB/documents/v1/EN.ZINIA.LINKUP.PRIVACY_POLICY_FLEXIBLE_PAYMENT.pdf ';

export { DATE_SEPARATOR, PRIVACY_POLICY_LINK_OTHERS, PRIVACY_POLICY_LINK_SPAIN };
